module.exports = __webpack_public_path__ + "img/101.42029ea8.jpg";